export default __webpack_public_path__ + "static/media/metalheads.e1c4b10e.gif";